// Locale-aware formatting — replaces the hardcoded 'en-CA' / '$' literals
// scattered through the legacy code. All formatters derive from the org's
// locale/currency/units settings.

import { getOrgContext } from './org.js';

function locale()   { return getOrgContext()?.locale   ?? 'en-CA'; }
function currency() { return getOrgContext()?.currency ?? 'CAD'; }

export function fmtDate(value, opts = { year: 'numeric', month: 'short', day: 'numeric' }) {
  const d = typeof value === 'string' ? new Date(value.length === 10 ? value + 'T12:00:00' : value) : value;
  return new Intl.DateTimeFormat(locale(), opts).format(d);
}

// Two dates as one range, the way the locale writes it: "Sep 5–13",
// "Aug 28–Sep 3", "June 1–October 10, 2026". The same day twice is one date.
export function fmtDateRange(from, to, opts = { month: 'short', day: 'numeric' }) {
  const d = v => new Date(v.length === 10 ? v + 'T12:00:00' : v);
  const f = new Intl.DateTimeFormat(locale(), opts);
  return from === to ? f.format(d(from)) : f.formatRange(d(from), d(to));
}

export function fmtMoney(value, opts = {}) {
  return new Intl.NumberFormat(locale(), {
    style: 'currency', currency: currency(),
    maximumFractionDigits: opts.decimals ?? 2,
    minimumFractionDigits: opts.decimals ?? 2,
  }).format(Number(value) || 0);
}

export function fmtNumber(value, decimals = 0) {
  return new Intl.NumberFormat(locale(), {
    maximumFractionDigits: decimals, minimumFractionDigits: decimals,
  }).format(Number(value) || 0);
}

// Unit labels per org measurement system. Field forms/estimating pass a
// semantic unit; tenants on metric see the metric counterpart.
const UNIT_LABELS = {
  imperial: { area: 'SF', length: 'LF', volume: 'yd³', temperature: '°F' },
  metric:   { area: 'm²', length: 'm',  volume: 'm³',  temperature: '°C' },
};

export function unitLabel(kind) {
  const units = getOrgContext()?.units ?? 'imperial';
  return UNIT_LABELS[units]?.[kind] ?? kind;
}
